import { useLanguage } from '../context/LanguageContext';

const WHATSAPP_NUMBER = '13054910131';

export default function MobileCallBar() {
  const { t } = useLanguage();
  const message = encodeURIComponent(t('whatsapp.defaultMessage'));

  return (
    <div className="mobile-call-bar">
      <a href="tel:+13054910131" className="mobile-call-bar-phone">
        <span className="mobile-call-bar-label">{t('mobileCallBar.label')}</span>
        <strong>(305) 491-0131</strong>
      </a>
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`}
        target="_blank"
        rel="noreferrer noopener"
        className="mobile-call-bar-whatsapp"
        aria-label={t('whatsapp.ariaLabel')}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22" fill="currentColor" aria-hidden="true">
          <path d="M16 0C7.163 0 0 7.163 0 16c0 2.824.737 5.474 2.027 7.782L0 32l8.418-2.007A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.79-1.866l-.487-.29-5.002 1.194 1.24-4.862-.317-.5A13.264 13.264 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.985c-.398-.199-2.353-1.161-2.718-1.294-.365-.133-.631-.199-.897.199-.266.398-1.03 1.294-1.263 1.56-.232.266-.465.299-.863.1-.398-.199-1.68-.619-3.2-1.973-1.183-1.054-1.981-2.355-2.213-2.753-.232-.398-.025-.614.175-.812.18-.179.398-.465.597-.698.199-.232.266-.398.398-.664.133-.266.067-.498-.033-.697-.1-.199-.897-2.163-1.229-2.961-.324-.777-.653-.672-.897-.684l-.764-.013c-.266 0-.697.1-1.063.498-.365.398-1.394 1.361-1.394 3.319s1.427 3.85 1.626 4.116c.199.266 2.808 4.287 6.803 6.013.951.41 1.693.655 2.271.838.954.303 1.823.26 2.51.158.765-.114 2.353-.962 2.685-1.891.332-.93.332-1.727.232-1.892-.1-.165-.365-.265-.763-.464z" />
        </svg>
        <span>WhatsApp</span>
      </a>
    </div>
  );
}

